import { Injectable } from "@angular/core";
import { BaseLoopBackApi, LoopBackFilter } from "../sdk";
import { ServerProvider } from "./server-provider";
import { Platform } from "ionic-angular";
import { AppVersion } from '@ionic-native/app-version';


/**
 * Controla datos temporales almacenados en cache del dispositivo
 */
@Injectable()
export class StorageCacheProvider {

    //valores de keys
    public static readonly STORAGE_KEYS = {
        STAGE_CRM_CLAIM_FILTERS: "stage_crm_claim",
        STOCK_WAREHOUSE_LOCATIONS: "stock_warehouse_locations",
        DELIVERY_NOTE_STOCK_WAREHOUSE_LOCATIONS_DEFAULT: "delivery_note_stock_warehouse_locations_default",
        VERSION_APP: "version_app",
        DEFAULT_HOST_ID: "default_host_id"
    }

    //valores en memoria
    public dataMemory:Array<any> = [];

    constructor(
        public platform: Platform,
        public appVersion: AppVersion
    ){
        this.checkIsRemoveDataCache();
    }

    /**
     * Comprueba la version actual de la app
     * Si son diferentes versiones, borra caches
     */
    public async checkIsRemoveDataCache(){

        let currentVersionApp = null;
        let previousVersionApp = null;

        //recuperar versiones
        if(this.platform.is("android") || this.platform.is("ios")){
            currentVersionApp = await this.appVersion.getVersionCode();
            previousVersionApp = await this.getStorageData(StorageCacheProvider.STORAGE_KEYS.VERSION_APP);

            console.log("currentVersionApp", currentVersionApp);
            console.log("previousVersionApp", previousVersionApp);
        }

        //comparar versiones
        if(!previousVersionApp || (previousVersionApp!=currentVersionApp)){

            //borrar caches
            this.deleteStorageData(StorageCacheProvider.STORAGE_KEYS.STAGE_CRM_CLAIM_FILTERS);

            //guardar version actual
            this.setStorageData(StorageCacheProvider.STORAGE_KEYS.VERSION_APP, currentVersionApp);
        }



    }

    /**
     *
     * Obtiene datos de cache
     *
     * Si no estan en memoria, accede a la cache
     * Si no estan en cache, recupera los datos del servidor
     *
     * @param service servicio a obtener los datos
     * @param keyStorage key del almacenamiento
     */
    public getDataCache(keyStorage:string, service:BaseLoopBackApi, query: LoopBackFilter):Promise<Array<any>>{

        return new Promise((resolve, reject) => {

            //mirar si estan en memoria
            if(this.dataMemory[keyStorage]){
                return resolve(this.dataMemory[keyStorage]);
            }else{
                //mirar si estan en caches
                this.getStorageData(keyStorage).then(success=>{
                    if(success){
                        //guardar en memoria
                        this.dataMemory[keyStorage] = success;
                        return resolve(this.dataMemory[keyStorage]);
                    }else{
                        //pedir a la nube
                        ServerProvider.find(service, query).subscribe(success => {
                            if(success){

                                //guardar en memoria
                                this.dataMemory[keyStorage] = success;

                                //guardar en caches
                                this.setStorageData(keyStorage, success);

                                return resolve(this.dataMemory[keyStorage]);
                            }else{
                                //no hay valores en server

                                return reject();
                            }
                        });

                    }
                }).catch(error => {
                    //pedir a la nube
                    return reject(error);
                });
            }

        });

    }

    /**
     * Recupera datos de memoria local
     * @param keyStorage
     */
    public getStorageData(keyStorage:string):Promise<any>{

        return new Promise((resolve, reject) => {

            let jsonStorage:string = window.localStorage.getItem(keyStorage);
            if(jsonStorage){
                try {
                    return resolve(JSON.parse(jsonStorage));
                } catch (e) {
                    console.warn(e);
                    return resolve(null);
                }
            }else{
                return resolve(null);
            }

        });
    }

    /**
     * Guarda datos en memoria local
     * @param key
     * @param value
     */
    public setStorageData(key:string, value:any):Promise<any>{
        return new Promise((resolve, reject) => {

            if(value){
                let jsonStorage = JSON.stringify(value);
                if(jsonStorage){
                    window.localStorage.setItem(key, jsonStorage);
                }
            }
        });
    }

    /**
     * Borra un item de memoria
     * @param key
     */
    public deleteStorageData(key:string){
        window.localStorage.removeItem(key);
    }






}


// WEBPACK FOOTER //
// ./src/providers/storage-cache-provider.ts